export const levels = [
  {
    id: 1,
    targetScore: 30,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['empty', 'block', 'block', 'empty', 'empty', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'empty', 'block', 'block', 'empty', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 2,
    targetScore: 30,
    maxSteps: 11,
    actualSize: 6,
    map: [
      ['empty', 'block', 'block', 'empty', 'empty', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'empty', 'empty', 'block', 'block', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 3,
    targetScore: 40,
    maxSteps: 20,
    actualSize: 6,
    map: [
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'empty', 'empty', 'empty'],
      ['block', 'block', 'block', 'empty', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'empty', 'empty', 'empty'],
      ['block', 'block', 'block', 'empty', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 4,
    targetScore: 40,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['block', 'block', 'empty', 'empty', 'empty', 'empty', 'block', 'block'],
      ['block', 'block', 'block', 'empty', 'empty', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'empty', 'empty', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'empty', 'empty', 'block', 'block', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 5,
    targetScore: 25,
    maxSteps: 8,
    actualSize: 6,
    map: [
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'empty', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'empty', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 6,
    targetScore: 30,
    maxSteps: 9,
    actualSize: 6,
    map: [
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 7,
    targetScore: 20,
    maxSteps: 10,
    actualSize: 5,
    cells: [
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    // bonusPositions: [
    //   [1, 1], [2, 1], [3, 1],
    //   [1, 2], [2, 2], [3, 2],
    // ],
    items: [
      // {
      //   type: "block",
      //   role: "bonus",
      //   name: "protected",
      //   isAlwaysPlayed: true,
      //   backClip: "frozenBack",
      //   frontClip: "frozenFront",
      // },
      // {
      //   type: "block",
      //   role: "color",
      //   name: "item_3_9",
      //   clip: "Item_3_9",
      //   frozen: true,
      //   count: 1,
      //   position: [3, 0],
      //   explosionClip: "Explosion"
      // },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 8,
    targetScore: 30,
    maxSteps: 10,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'block', 'block', 'block', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'block', 'block', 'block', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 9,
    targetScore: 40,
    maxSteps: 10,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'empty', 'block', 'block', 'empty', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'empty', 'block', 'block', 'empty', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 10,
    targetScore: 40,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['empty', 'block', 'empty', 'empty', 'empty', 'block', 'block'],
      ['block', 'block', 'block', 'empty', 'empty', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'empty', 'block', 'block'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'empty', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 11,
    targetScore: 50,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 12,
    targetScore: 60,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'empty', 'block', 'block', 'empty', 'empty', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'empty', 'empty', 'block', 'block', 'empty', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 13,
    targetScore: 40,
    maxSteps: 20,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'empty', 'empty', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'empty', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'empty', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'empty', 'empty', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 14,
    targetScore: 50,
    maxSteps: 20,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'block', 'empty', 'empty', 'block', 'empty', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'empty', 'block', 'empty', 'empty', 'block', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 15,
    targetScore: 80,
    maxSteps: 20,
    actualSize: 6,
    map: [
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 16,
    targetScore: 60,
    maxSteps: 20,
    actualSize: 6,
    map: [
      ['block', 'block', 'empty', 'empty', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'empty', 'empty', 'block', 'block'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 17,
    targetScore: 30,
    maxSteps: 10,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'empty', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'empty', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'empty', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'empty', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'empty', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 18,
    targetScore: 35,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'empty', 'block', 'block', 'empty', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'empty', 'block', 'block', 'empty', 'empty', 'empty'],
      ['empty', 'empty', 'empty', 'block', 'block', 'empty', 'empty', 'empty'],
      ['empty', 'empty', 'empty', 'block', 'block', 'empty', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 19,
    targetScore: 40,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['empty', 'block', 'block', 'empty', 'empty', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'empty', 'empty', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'empty', 'empty', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'empty', 'empty', 'block', 'block', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 20,
    targetScore: 60,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'empty', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'empty', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'empty', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'empty', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 21,
    targetScore: 50,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'empty', 'block', 'block', 'block', 'block', 'block'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 22,
    targetScore: 50,
    maxSteps: 20,
    actualSize: 6,
    map: [
      ['block', 'block', 'block', 'block', 'empty', 'empty', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'empty', 'empty', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'empty', 'empty', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'empty', 'empty', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'empty', 'empty', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'empty', 'empty', 'block', 'block', 'block', 'block'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 23,
    targetScore: 50,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 24,
    targetScore: 70,
    maxSteps: 20,
    actualSize: 6,
    map: [
      ['block', 'block', 'block', 'empty', 'empty', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'empty', 'empty', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 25,
    targetScore: 50,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'block', 'block', 'block', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 26,
    targetScore: 50,
    maxSteps: 15,
    actualSize: 6,
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 27,
    targetScore: 40,
    maxSteps: 10,
    actualSize: 6,
    map: [
      ['empty', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 28,
    targetScore: 50,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['block', 'block', 'block', 'block', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'block', 'block', 'block', 'block'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 29,
    targetScore: 50,
    maxSteps: 17,
    actualSize: 6,
    map: [
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 30,
    targetScore: 40,
    maxSteps: 10,
    actualSize: 6,
    map: [
      ['empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 31,
    targetScore: 50,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'empty', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'empty', 'block', 'block'],
      ['block', 'block', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 32,
    targetScore: 65,
    maxSteps: 20,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 33,
    targetScore: 55,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 34,
    targetScore: 60,
    maxSteps: 20,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'empty', 'empty', 'empty'],
      ['block', 'block', 'block', 'block', 'empty', 'empty', 'empty'],
      ['empty', 'block', 'block', 'block', 'empty', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 35,
    targetScore: 55,
    maxSteps: 15,
    actualSize: 6,
    map: [
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'empty', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'empty', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'empty', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 36,
    targetScore: 65,
    maxSteps: 20,
    actualSize: 6,
    map: [
      ['empty', 'empty', 'empty', 'block', 'block', 'empty', 'empty', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['block', 'block', 'block', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'empty', 'block', 'block', 'block', 'block', 'empty', 'empty'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
  {
    id: 37,
    targetScore: 65,
    maxSteps: 20,
    actualSize: 6,
    map: [
      ['block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'empty'],
      ['block', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'empty'],
      ['empty', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block'],
      ['empty', 'block', 'block', 'block', 'block', 'block'],
    ],
    cells: [
      {
        type: 'empty',
        isGenerate: false,
      },
      {
        type: 'block',
        isGenerate: true,
      },
    ],
    items: [
      {
        type: 'block',
        role: 'color',
        name: 'item_1_0',
        clip: 'Item_1_0',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_1',
        clip: 'Item_1_1',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_2',
        clip: 'Item_1_2',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_3',
        clip: 'Item_1_3',
        explosionClip: 'Explosion',
      },
      {
        type: 'block',
        role: 'color',
        name: 'item_1_4',
        clip: 'Item_1_4',
        explosionClip: 'Explosion',
      },
    ],
  },
];
